import React, { useEffect } from "react";
import { logout } from "../app/features/authSlice";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";
import Loader from "../components/Loader";
import { setResetData } from "../app/features/DataSlice";
import { apiSlice } from "../app/features/apiSlice";

const clearCookies = () => {
  document.cookie.split(";").forEach((cookie) => {
    const name = cookie.split("=")[0].trim();
    if (name) {
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    }
  });
};

const Logout = () => {
  const { lang } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setResetData());
    dispatch(logout());
    dispatch(apiSlice.util.resetApiState());
    clearCookies();
    navigate(`/${lang}/dashboard`);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  return <Loader />;
};

export default Logout;
